module.exports = __webpack_public_path__ + "static/img/4.55dc0f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/4.png
// module id = tlSE
// module chunks = 0